<!--
* @program: TYH_office_automation 
* @author: ly
* @component:typeSelector 
* @description: 
* @create: 2021-07-07 15:33
-->
<template>
    <div class="data-present">
        <div v-if="viewModel">
            <div >{{presentValue}}</div>
        </div>
        <div v-else>
            <a-select
                    v-if="editable"
                    v-model:value="record[column.dataIndex]"
                    @select="handleSelect"
                    @change="columnTrigger"
            >
                <a-select-option v-for="option in options" :key="option.id">
                    {{ option.name }}
                </a-select-option>
            </a-select>
            <div v-else >{{presentValue}}</div>
        </div>
    </div>
</template>

<script>
    import typeBase from "./typeBase";
    import {computed} from "vue";

    export default {
        name: "typeSelector",
        mixins:[typeBase],
        computed:{
            presentValue(){
                return this.record[this.column.selectorObject.replaceSegment]?this.record[this.column.selectorObject.replaceSegment]:"无"
            }
        },
        data(){
            return{
                //查询到的选项
                options:computed(()=>this.column.selectorObject.options),
            }
        },
        methods:{
            handleSelect(value, option){
                this.record[this.column.selectorObject.replaceSegment] = option.name;
            }
        }
    }
</script>

<style scoped>

</style>